var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"laudos"}},[_c('SelecionarTerritorio',{ref:"selecionarTerritorio",attrs:{"tipoLaudo":_vm.tipoLaudo},on:{"getTerritoriosSelecionados":_vm.solicitarLaudos,"cancelar-modal":_vm.changeShowModalSelecionarTerritorio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }